import React from 'react'

import { FORM_CONTROL_BG_COLOR } from './constants'

import MultiSelect from 'components/MultiSelect'
import WarningDot from 'components/Profile/WarningDot'

const SELECTED_BG_COLOR = '#191e23'

const ProfileMultiSelect = ({ showRequired, value, options, ...rest }) => {
  const formattedValue =
    value?.map(data => ({
      value: data,
      label: options.find(option => option.value === data)?.label || data,
    })) || []

  return (
    <div className="relative">
      <MultiSelect
        styles={{
          option: (provided, state) => ({
            backgroundColor: state.isSelected ? SELECTED_BG_COLOR : FORM_CONTROL_BG_COLOR,
          }),
          control: () => ({
            backgroundColor: FORM_CONTROL_BG_COLOR,
          }),
        }}
        options={options}
        value={formattedValue}
        {...rest}
      />
      {showRequired && !rest.value?.length && (
        <div className="absolute top-1/2 right-9 transform -translate-y-1/2">
          <WarningDot className="" />
        </div>
      )}
    </div>
  )
}

export default ProfileMultiSelect
